import { User } from '@tassomutuo-backoffice/types';
import { CtaButton, ModalContainer } from '@tassomutuo-backoffice/ui';
import {
  Box,
  TextField,
  Typography,
} from '@mui/material';
import { useState, useEffect } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateUserTelephone } from '../../../../services/api/team/team';
import { toast } from 'react-toastify';

interface IProps {
  handleClose: () => void;
  user: User;
}

const TeamMemberEditTelephoneModal = ({
  handleClose,
  user,
}: IProps) => {
  const queryClient = useQueryClient();
  const [isLoading, setIsLoading] = useState(false);
  const [telephoneNumber, setTelephoneNumber] = useState('');

  useEffect(() => {
    if (user?.telephoneNumber) {
      setTelephoneNumber(user.telephoneNumber);
    }
  }, [user]);

  const updateUserCollaboratoriTelephone = useMutation({
    mutationFn: (data: { userId: string; telephone: string }) => {
      return updateUserTelephone(data.userId, data.telephone);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['UsersTeam'],
      });
      toast.success('Numero di telefono aggiornato con successo!');
    },
    onError: (error) => {
      toast.error(error.message || 'Si è verificato un errore, riprova!');
    },
  });

  const handleTelephoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTelephoneNumber(e.target.value);
  };

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!user || !user.id) {
      toast.error('Utente non valido.');
      return;
    }

    if (!telephoneNumber.trim()) {
      toast.error('Inserisci un numero di telefono valido.');
      return;
    }

    try {
      setIsLoading(true);
      await updateUserCollaboratoriTelephone.mutateAsync({
        userId: user.id,
        telephone: telephoneNumber,
      });
      handleClose();
    } catch (error) {
      console.error('Errore durante il salvataggio:', error);
      toast.error('Errore durante il salvataggio, riprova più tardi!');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ModalContainer
      open
      handleClose={handleClose}
      title={`Modifica Telefono - ${user.name || user.email}`}
      containerSx={{ maxWidth: '600px' }}
      mtHeader={0}
    >
      <Box width="100%" component="form" onSubmit={onSubmit}>
        <Box mb={3}>
          <TextField
            fullWidth
            label="Numero di telefono"
            value={telephoneNumber}
            onChange={handleTelephoneChange}
            placeholder="+39-3201234567"
            helperText="Formato suggerito: +39-3201234567"
            variant="outlined"
          />
        </Box>

        {telephoneNumber && (
          <Box mb={3} p={2} sx={{ backgroundColor: '#f5f5f5', borderRadius: 1 }}>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              Numero attuale:
            </Typography>
            <Typography variant="body1" fontWeight="medium">
              {telephoneNumber}
            </Typography>
          </Box>
        )}

        <Box display="flex" justifyContent="center" gap={2} my={4}>
          <CtaButton
            variant="contained"
            type="submit"
            loading={isLoading}
            disabled={!telephoneNumber.trim() || isLoading}
          >
            SALVA TELEFONO
          </CtaButton>
        </Box>
      </Box>
    </ModalContainer>
  );
};

export default TeamMemberEditTelephoneModal;
